<template>
  <div>
    <v-page background-color="#FFF" :background="require('@/assets/watermerk.svg?fill=#F7F7F7')" style="background-size: 100%;background-position:center;" class="py-16" no-auto-height>
      <v-container :fluid="$vuetify.breakpoint.mdOnly">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6" lg="7">
            <!--<v-img :src="require('@/assets/zonnebaden of wandelen.jpg')"></v-img>-->
                <v-img :aspect-ratio="16/9" :src="require('@/assets/zonnebaden of wandelen.jpg')"></v-img>
          </v-col>
          <v-col>
            <v-row>
              <v-col><h1 class="dz c-primary" style="font-size: 3rem;">{{ $t("natuur.flora-header") }}</h1></v-col>
            </v-row>
            <v-row>
              <v-col class="text-left">{{ $t("natuur.flora") }}</v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-page>
    <v-page background-color="#282828" style="background-size: 100%;background-position:center;" class="py-16" no-auto-height dark>
      <v-container :fluid="$vuetify.breakpoint.mdOnly">
        <v-row justify="center" align="center">
          <v-col>
            <v-row>
              <v-col><h1 class="dz c-primary" style="font-size: 3rem;">{{ $t("natuur.zonnebaden-header") }}</h1></v-col>
            </v-row>
            <v-row>
              <v-col class="text-left">{{ $t("natuur.zonnebaden") }}</v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" lg="7">
            <v-carousel class="slider" cycle height="100%" hide-delimiters>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/strand en vliegers.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/foto2.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/wandelende mensen.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/man met vlieger.jpg')"></v-img>
              </v-carousel-item>
            </v-carousel>

          </v-col>
        </v-row>
      </v-container>
    </v-page>
    <v-page background-color="#91B6BA" :background="require('@/assets/watermerk.svg?fill=#FFFFFF')" style="background-size: 100%;background-position:center;" class="py-16" no-auto-height>
      <v-container :fluid="$vuetify.breakpoint.mdOnly">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6" lg="7">
            <v-carousel class="slider" cycle height="100%" hide-delimiters>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/vliegers.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/gras.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/gebouw.jpg')"></v-img>
              </v-carousel-item>
              <v-carousel-item>
                <v-img :aspect-ratio="16/9" :src="require('@/assets/strand.jpg')"></v-img>
              </v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col>
            <v-row>
              <v-col><h1 class="dz" style="font-size: 4rem;">{{ $t("natuur.haven-header") }}</h1></v-col>
            </v-row>
            <v-row>
              <v-col class="text-left">
                {{ $t("natuur.haven") }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-page>
    <Footer></Footer>
  </div>
</template>

<script>
import VPage from "@/components/VPage";
import Footer from "@/views/Footer";

export default {
  name: "Natuur",
  components: {VPage, Footer},
  items: [
    {
      src: ""
    }
  ]

}
</script>

<style>
.slider .v-window__next, .slider .v-window__prev {
  background: transparent !important;
}
</style>